import CategoriesGrid from '../../components/Categories/CategoriesGrid'
import PageTitle from '../../components/common/PageTitle'
import SeoHelmet from '../../components/common/SeoHelmet'

const CategoriesProductsPage = () => {
  return (
    <div className="main-container">
      <SeoHelmet
        title="Shop by Category"
        description="Browse top product categories from Eastleigh's best retailers and wholesalers. Fashion, electronics, home goods, and more on Sokooni."
        keywords="product categories, Eastleigh marketplace, Sokooni, wholesale fashion, electronics, home goods, Kenya ecommerce"
        url="/categories"
      />

      <PageTitle>Categories</PageTitle>
      <CategoriesGrid />
    </div>
  )
}

export default CategoriesProductsPage
